import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth, API } from "@/App";
import axios from "axios";
import { toast } from "sonner";

const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const code = searchParams.get("code");
      const state = searchParams.get("state");
      const error = searchParams.get("error");

      if (error) {
        toast.error("Google login was cancelled or failed");
        navigate("/login", { replace: true });
        return;
      }

      if (!code || !state) {
        toast.error("Invalid callback parameters");
        navigate("/login", { replace: true });
        return;
      }

      try {
        const response = await axios.post(
          `${API}/integrations/google/callback`,
          { code, state },
          { withCredentials: true }
        );

        // Update user context with the response
        updateUser({
          ...response.data.user,
          token: response.data.access_token
        });

        // Store token in localStorage for persistence
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        toast.success("Welcome! Gmail is automatically connected for sending proposals.");
        navigate("/dashboard", { replace: true });
      } catch (error) {
        console.error("Google auth callback error:", error);
        toast.error(error.response?.data?.detail || "Failed to complete Google login");
        navigate("/login", { replace: true });
      }
    };

    processCallback();
  }, [navigate, searchParams, updateUser]);

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center">
      <div className="text-center">
        <div className="animate-pulse text-forest font-display text-2xl mb-2">
          Signing you in...
        </div>
        <p className="text-muted-foreground">Connecting your Google account with email access</p>
      </div>
    </div>
  );
};

export default GoogleAuthCallback;
